import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getStatus } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiUrls } from "@/store/api/constants";

export default function useOnActions() {
  const [isAlertDialog, setIsAlertDialog] = useState(false);

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const state = useSelector((store) => store);
  const [currentRowId, setCurrentRowId] = useState(null);



  const deleteDropdownMasterStatus = getStatus(state, apiKeys.deleteDropdownMaster, '');

  const onCloseAlert = useCallback(() => {
    setIsAlertDialog((prevState) => !prevState);
    setCurrentRowId(null);
  }, []);

  const onAgreeAlert = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.deleteDropdownMaster(currentRowId),
      method: apiMethods.DELETE,
      key: apiKeys.deleteDropdownMaster,
      successMsg: formatMessage({ id: "dropdown-master-has-been-deleted-successfully" }),
      failureMsg: formatMessage({ id: "failed-to-delete-dropdown-master" }),
    }))
    onCloseAlert();
  }, [dispatch, formatMessage, onCloseAlert, currentRowId]);


  const onRowDelete = useCallback((id) => {
    setCurrentRowId(id);
    setIsAlertDialog(true);
  }, []);



  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.deleteDropdownMaster }));
  }, [dispatch]);


  return useMemo(() => ({
    onRowDelete,
    deleteDropdownMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,

  }), [
    onRowDelete,
    deleteDropdownMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
  ])
}
